<template>
  <section class="full-height">
    <Menu />
    <div class='title' v-html="$t('home')">
    </div>
  <button @click="scrollToServices()" class="scroll">
  <svg width="20" height="13" viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.33325 1.28577L9.99992 9.95243L18.6666 1.28577" stroke="black" stroke-width="3"/>
</svg>
  </button>
  </section>
</template>

<script>
import Menu from '../components/Menu'

export default {
  name: 'Hero',
  components: {
    Menu
  },
  methods: {
    scrollToServices() {
      window.scrollBy(0, window.innerHeight);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .scroll {
    transition: 0.3s;
    position: absolute;
    background-color: white;
    border: 4px solid rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    outline: none;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    height: 50px;
    width: 50px;
    bottom: 25px;
    text-align: center;
  }
  .scroll:focus {
    border: 4px solid rgba(0, 0, 0, 0.25);
  }
  svg {
   height: 20px;
  }
  .scroll:hover {
    background-color: rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.1);
  }
  .title {
    font-family: Lora, serif;
    font-style: normal;
    font-weight: bold;
    font-size: 65px;
    line-height: 105px;

    text-align: center;

    color: rgba(63, 63, 63, 0.9);

    top: calc(50% - 220px);
    position: relative;

    animation: top-fadein 3s ease-out forwards;
    animation-iteration-count: 1;

    /* Safari and Chrome */
    -webkit-animation: top-fadein 3s;
    -webkit-animation-iteration-count: 1;
  }

  @keyframes top-fadein {
    from {
      top:calc(50% - 320px);
      opacity: 0;
    }

    to {
      top:calc(50% - 220px);
      opacity: 1.5;
    }
  }

  @media (max-width: 575.98px) {
    .title {
      font-size: 35px;
      line-height: 50px;
    }
  }
</style>
